// extracted by mini-css-extract-plugin
module.exports = {"layout":"waypoint_layout__98Z8k","year":"waypoint_year__UeAtI","value":"waypoint_value___jBXH"};